/** Textos del media kit (brochure PDF) — hero + bloques relacionados. */
export const LEGALMENTE_EJES_LISTA = [
  'Trayectoria: 12 años de experiencia comprobada como Consejera de Protección (LOPNNA).',
  'Máxima distinción: Condecorada en 2025 con la Orden «Miguel José Sanz» (1.ª clase) del Ilustre Colegio de Abogados de Caracas.',
  'Voz empresarial: Ponente invitada en la Comisión de Seguridad de FEDECÁMARAS 2025 — prevención de acoso escolar en el debate corporativo.',
  'Impacto social: Co-fundadora de la Asociación Civil Justicia4.cero y asesora aliada de ONG.',
];

export const LEGALMENTE_PARRAFO_ALFABETIZACION =
  'Un espacio diseñado para la alfabetización legal, promoviendo la educación jurídica preventiva. Traducimos lo complejo del marco legal en acciones claras para la cotidianidad del hogar, la protección de la salud y la seguridad en entornos digitales y presenciales.';
